// @flow

import type {
  AuthState,
} from '../../types'

import {
  ACCEPT_EULA,
  CHECK_EULA_STATUS,
  POST_EULA_STATUS,
} from '../constants'

// Reducers
function acceptEula (state: AuthState, payload: Object): AuthState {
  return {
    ...state,
    eulaSigned: payload,
    isFetchingEulaSigned: false,
  }
}

function checkEulaStatus (state: AuthState): AuthState {
  return {
    ...state,
    eulaSigned: false,
    isFetchingEulaSigned: true,
  }
}

function postEulaStatus (state: AuthState): AuthState {
  return state
}

export default function composeEulaReducers (): Object {
  return {
    [ACCEPT_EULA]: acceptEula,
    [CHECK_EULA_STATUS]: checkEulaStatus,
    [POST_EULA_STATUS]: postEulaStatus,
  }
}
